// Remembered visitor choices (language, theme). They persist across visits only when the
// visitor allowed "preferences" cookies; otherwise they last for the current tab.
import { hasConsent } from "./consent";

export const PREFERENCE_KEYS = {
  lang: "applumo_lang",
  theme: "applumo_theme",
};

// The tab's choice wins over an older remembered one.
export const readPreference = (key) => {
  try {
    return sessionStorage.getItem(key) || localStorage.getItem(key);
  } catch {
    return null;
  }
};

export const savePreference = (key, value) => {
  try {
    if (hasConsent("preferences")) {
      localStorage.setItem(key, value);
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
    }
  } catch {
    /* storage unavailable: the choice still applies for this visit */
  }
};

// Called when preferences are denied: forget anything remembered across visits.
export const clearPreferences = () => {
  try {
    Object.values(PREFERENCE_KEYS).forEach((k) => localStorage.removeItem(k));
  } catch {
    /* nothing stored */
  }
};
